<!DOCTYPE html>
<html lang="es">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Carga Sistema Legal</title>
    <style>
        body {
            margin: 0;
            padding: 0;
            background-color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 100vh;
            font-family: 'Arial', sans-serif;
        }

        .loading-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .legal-loader {
            position: relative;
            width: 120px;
            height: 120px;
            margin-bottom: 30px;
        }

        /* Elemento central - Martillo de juez */
        .gavel {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 60px;
            height: 25px;
        }

        .gavel-head {
            position: absolute;
            width: 35px;
            height: 12px;
            background-color: #1B3F3F;
            border-radius: 6px;
            top: 0;
            left: 0;
            animation: gavelTap 2s ease-in-out infinite;
            transform-origin: right center;
        }

        .gavel-handle {
            position: absolute;
            width: 30px;
            height: 4px;
            background-color: #1B3F3F;
            border-radius: 2px;
            top: 10px;
            right: 0;
            animation: gavelTap 2s ease-in-out infinite;
            transform-origin: left center;
        }

        /* Documentos flotantes */
        .document {
            position: absolute;
            width: 20px;
            height: 26px;
            background-color: #1B3F3F;
            border-radius: 2px;
            opacity: 0;
        }

        .document::before {
            content: '';
            position: absolute;
            top: 3px;
            left: 3px;
            right: 3px;
            height: 2px;
            background-color: white;
            border-radius: 1px;
        }

        .document::after {
            content: '';
            position: absolute;
            top: 8px;
            left: 3px;
            right: 6px;
            height: 1px;
            background-color: white;
            border-radius: 1px;
        }

        .doc1 {
            top: -10px;
            left: -15px;
            animation: floatDoc1 4s ease-in-out infinite;
        }

        .doc2 {
            top: -5px;
            right: -20px;
            animation: floatDoc2 4s ease-in-out infinite 0.5s;
        }

        .doc3 {
            bottom: -15px;
            left: -20px;
            animation: floatDoc3 4s ease-in-out infinite 1s;
        }

        .doc4 {
            bottom: -10px;
            right: -15px;
            animation: floatDoc4 4s ease-in-out infinite 1.5s;
        }

        /* Círculo de progreso */
        .progress-ring {
            position: absolute;
            top: -10px;
            left: -10px;
            width: 140px;
            height: 140px;
        }

        .progress-circle {
            fill: none;
            stroke: #1B3F3F;
            stroke-width: 2;
            stroke-linecap: round;
            stroke-dasharray: 440;
            stroke-dashoffset: 440;
            transform: rotate(-90deg);
            transform-origin: 50% 50%;
            animation: progressFill 3s ease-in-out infinite;
            opacity: 0.3;
        }

        /* Texto de carga */
        .loading-text {
            color: #1B3F3F;
            font-size: 18px;
            font-weight: 600;
            letter-spacing: 1px;
            margin-bottom: 10px;
            animation: textPulse 2s ease-in-out infinite;
        }

        .loading-subtext {
            color: #1B3F3F;
            font-size: 12px;
            opacity: 0.7;
            animation: subtextFade 3s ease-in-out infinite;
        }

        /* Puntos de carga */
        .dots {
            display: inline-block;
        }

        .dot {
            display: inline-block;
            width: 4px;
            height: 4px;
            background-color: #1B3F3F;
            border-radius: 50%;
            margin: 0 2px;
            animation: dotBounce 1.4s ease-in-out infinite both;
        }

        .dot:nth-child(1) { animation-delay: -0.32s; }
        .dot:nth-child(2) { animation-delay: -0.16s; }
        .dot:nth-child(3) { animation-delay: 0s; }

        /* Animaciones */
        @keyframes gavelTap {
            0%, 100% { transform: rotate(0deg); }
            20% { transform: rotate(-15deg); }
            40% { transform: rotate(0deg); }
            60% { transform: rotate(-10deg); }
            80% { transform: rotate(0deg); }
        }

        @keyframes floatDoc1 {
            0% { opacity: 0; transform: translateY(20px) rotate(0deg); }
            20% { opacity: 1; }
            50% { transform: translateY(-10px) rotate(5deg); }
            80% { opacity: 1; }
            100% { opacity: 0; transform: translateY(-30px) rotate(10deg); }
        }

        @keyframes floatDoc2 {
            0% { opacity: 0; transform: translateY(20px) rotate(0deg); }
            20% { opacity: 1; }
            50% { transform: translateY(-10px) rotate(-5deg); }
            80% { opacity: 1; }
            100% { opacity: 0; transform: translateY(-30px) rotate(-10deg); }
        }

        @keyframes floatDoc3 {
            0% { opacity: 0; transform: translateY(-20px) rotate(0deg); }
            20% { opacity: 1; }
            50% { transform: translateY(10px) rotate(-3deg); }
            80% { opacity: 1; }
            100% { opacity: 0; transform: translateY(30px) rotate(-8deg); }
        }

        @keyframes floatDoc4 {
            0% { opacity: 0; transform: translateY(-20px) rotate(0deg); }
            20% { opacity: 1; }
            50% { transform: translateY(10px) rotate(3deg); }
            80% { opacity: 1; }
            100% { opacity: 0; transform: translateY(30px) rotate(8deg); }
        }

        @keyframes progressFill {
            0% { stroke-dashoffset: 440; }
            50% { stroke-dashoffset: 0; }
            100% { stroke-dashoffset: 440; }
        }

        @keyframes textPulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.6; }
        }

        @keyframes subtextFade {
            0%, 100% { opacity: 0.7; }
            50% { opacity: 0.3; }
        }

        @keyframes dotBounce {
            0%, 80%, 100% {
                transform: scale(0);
                opacity: 0.5;
            }
            40% {
                transform: scale(1);
                opacity: 1;
            }
        }

        /* Efectos adicionales */
        .legal-loader::before {
            content: '';
            position: absolute;
            top: -20px;
            left: -20px;
            right: -20px;
            bottom: -20px;
            border: 1px solid #1B3F3F;
            border-radius: 50%;
            opacity: 0.1;
            animation: ringPulse 4s ease-in-out infinite;
        }

        @keyframes ringPulse {
            0%, 100% {
                transform: scale(0.8);
                opacity: 0.1;
            }
            50% {
                transform: scale(1.1);
                opacity: 0.3;
            }
        }
    </style>
</head>
<body>
    <div class="loading-container">
        <div class="legal-loader">
            <!-- Círculo de progreso -->
            <svg class="progress-ring" viewBox="0 0 140 140">
                <circle class="progress-circle" cx="70" cy="70" r="70"/>
            </svg>

            <!-- Documentos flotantes -->
            <div class="document doc1"></div>
            <div class="document doc2"></div>
            <div class="document doc3"></div>
            <div class="document doc4"></div>
        </div>

        <div class="loading-text">
            CARGANDO
        </div>
        <div class="loading-subtext">
            Preparando sistema<span class="dots">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
            </span>
        </div>
    </div>
</body>
</html>
